export default {
	tiny: 280,
	mobile: 380,
	tablet: 580,
	desktop: 880,
	wide: 1160,
	super: 1340,
	extreme: 1520,
};
